import React, { memo } from 'react';
import { useObserver } from 'mobx-react';
import { Flex } from 'antd-mobile';
import PropTypes from 'prop-types';
import Util from 'utils';
import { ImgWrap } from 'pubBiz';

const useAppModData = () => {
  const { userInfo } = Util.useStores('AppMod');
  return useObserver(() => ({
    userInfo
  }));
};

const HorizontalGrid = memo((props) => {
  const {
    width: cellWidth, // Any 容器宽度
    data, // Array 数据源
    onPress // Function 点击事件
  } = props;
  const { userInfo } = useAppModData();

  const renderItem = (item, index) => {
    const { content, id, imgInfo } = item;
    const { imgUrl, width, height } = imgInfo;
    const imgWidth = cellWidth;
    const imgHeight = `calc(${imgWidth} * (${height} / ${width}))`;

    try {
      // 店长 申请开店推荐位隐藏 @杨志友
      if (content && JSON.parse(content).route === 'Yundian' && userInfo && userInfo.cstoreId) {
        return null;
      }
    } catch (err) {}

    try {
      // 消费VIP 消费VIP推荐位隐藏 @陈琼
      if (content && id === '1333679383086527538' && userInfo && userInfo.isConsumeVip === 1) {
        return null;
      }
    } catch (err) {}

    return (
      <Flex key={`HorizontalGrid${index}`} onClick={() => onPress && onPress(item)}>
        <ImgWrap src={imgUrl || ''} mode={'cover'} w={imgWidth} h={imgHeight} />
      </Flex>
    );
  };

  return <Flex>{data.map((item, index) => renderItem(item, index))}</Flex>;
});

HorizontalGrid.defaultProps = {
  data: [],
  onPress: null
};

// imgInfo成员结构
const imgInfoPropTypes = PropTypes.shape({
  imgUrl: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
});

// data成员结构
const dataPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    imgInfo: imgInfoPropTypes.isRequired,
    id: PropTypes.string,
    type: PropTypes.string,
    content: PropTypes.string,
    extend: PropTypes.object
  })
);

HorizontalGrid.propTypes = {
  width: PropTypes.any.isRequired, // 容器宽度
  data: dataPropTypes, // 数据源
  onPress: PropTypes.func // 点击事件
};

export default HorizontalGrid;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/RecommandCell/components/HorizontalGrid/index.js